import { Injectable } from '@angular/core';
import { lang } from './lang';
import * as CryptoJS from 'crypto-js';
import {constants} from './constants'
import { PrivacyService } from './privacy/privacy.service';
@Injectable({
  providedIn: 'root'
})
export class CommonUtilitiesService {

  constructor(
    private privacyService: PrivacyService
  ) { 
    this.getCodeAesParam();
  }

   /**
   * Description: Método que obtiene el key o nombre de atributo de la constante de lenguaje y retorna el valor de la misma.
   * Autor: Diego Diaz
   * @param keyLabel contiene el identificador del atributo de lenguaje a obtener
   * @return Retorna el valor del atributo
   */
  getLangText(keyLabel){
    for(let arrayKey in lang) {
      if(arrayKey == keyLabel){
        return lang[arrayKey];
      }
    }
  }

  /**
   * Description: Método que retorna si existe una sesión activa
   * Autor: Diego Diaz
   * @param N/A
   * @return Retorna el estado de la sesión
   */
  isLogged(){
    if ((localStorage.getItem("userData") != null) &&
      (JSON.parse(localStorage.getItem("userData")).token != "")) {
       return true;
    }
    return false;
  }

    /**
   * Description: Método que valida si el numero contiene el prefijo 0 
   * Autor: Diego Diaz
   * @param phone numero a validar
   * @return confirmacion de la validacion
   */
  isValidPhoneZero(phone){
    if(phone.charAt(0) == '0'){
      return true;
    }    
    return false;
  }
  
  
   /**
   * Description: Método valida si el navegador es IE
   * Autor: Diego Diaz
   * @param N/A
   * @return confirmacion de la operacion
   */
	detectIEEdge() {
	  var response = 0;
	  var ua = window.navigator.userAgent;
	  var msie = ua.indexOf('MSIE ');
	  if (msie > 0) {
		  response = 10;
	  }
	  var trident = ua.indexOf('Trident/');
	  if (trident > 0) {
		  response = 11;
	  }
	  var edge = ua.indexOf('Edge/');
	  if (edge > 0) {
		  response = 12;
	  }
	  return response;
	}
	
   /**
   * Description: Método que convierte base64 en blob
   * Autor: Diego Diaz
   * @param base64Data, contentType
   * @return data convertida
   */
	base64toBlob(base64Data, contentType) {
		contentType = contentType || '';
		var sliceSize = 1024;
		var byteCharacters = atob(base64Data);
		//var byteCharacters = decodeURIComponent(escape(window.atob(base64Data)))
		var bytesLength = byteCharacters.length;
		var slicesCount = Math.ceil(bytesLength / sliceSize);
		var byteArrays = new Array(slicesCount);

		for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
			var begin = sliceIndex * sliceSize;
			var end = Math.min(begin + sliceSize, bytesLength);

			var bytes = new Array(end - begin);
			for (var offset = begin, i = 0 ; offset < end; ++i, ++offset) {
				bytes[i] = byteCharacters[offset].charCodeAt(0);
			}
			byteArrays[sliceIndex] = new Uint8Array(bytes);
		}
		return new Blob(byteArrays, { type: contentType });
	}
  
  encrypt(data: any): string {
    const iv = CryptoJS.enc.Utf8.parse(constants.CODE_IV);
    const key = CryptoJS.enc.Utf8.parse(constants.CODE_KP);
    const jsonString = JSON.stringify(data);
    const encrypted = CryptoJS.AES.encrypt(jsonString, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  }

  getCodeAesParam(){
		this.privacyService.getGroupParameters("WS_CAMPO").subscribe(((dataResponse:any) => {
      const [valueIV,valueKP] = dataResponse.obj[0].value.split(":");
      constants.CODE_IV= valueIV;
      constants.CODE_KP= valueKP;
		}))
	}

}
